// @flow
import PaidPeriod from './PaidPeriod';

export default PaidPeriod;
